import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { View } from 'react-native';

import Geosuggest from 'react-geosuggest';

import './Photos.css';
import { EventViewSplitPane } from './Event'
import { Modal, ComboBox, PublicityPicker, AlbumAddModal, PhotoAddModal, PhonePicker, ConfirmModal, FilePostViewer, EmptyState } from './Common';

export default class Photos extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: (!this.props.isAdmin) ? "Photos of " + FakeData.nullify(this.props.author).split(" ")[0] : "Your Photos",
            userTabs: (!this.props.isAdmin) ? ["Photos of " + FakeData.nullify(this.props.author).split(" ")[0], FakeData.nullify(this.props.author).split(" ")[0] + "'s Photos", "Albums"] : ["Photos of You", "Your Photos", "Albums"],
            isViewingMedia: false,
            isManaging: false,
            item: null,
            notYours: null,
            post: {
				content: "",
				rawContent: "",
				postType: "normal",
				media: [],
				links: [],
				tags: [],
				audienceList: [],
				place: { name: "" },
				coord: { lat: 0, lng: 0 }
            },
            linkImages: []
        }

		this.onPost = this.onPost.bind(this);
		this.onAddFiles = this.onAddFiles.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.getSelectedFromThem(nextProps.data.tagged)
        this.getSelectedFromYours(nextProps.data.uploads)
    }

    onLike(post) {
        const dataTo = {
            user: FakeData.getData("yoo"),
            type: "file",
            contentId: post.id,
            userOne:post.user,
            userTwo:post.userTo,
            users:post.tags,
            userType:this.props.userType
        }
        const _that = this

        FakeData.post('/likeContent.php?auth0', dataTo, {
            success: ((res) => {

            }),
            error: ((err) => {

            })
        })
    }

    getSelectedFromYours(arr) {
        if (this.state.item === null) {
            return;
        }

        let bool = false;

        for (let x = 0; x < arr.length; x++) {
            if (arr[x].id === this.state.item.id) {
                this.setState({ item: arr[x] });
                break;
            }
        }
    }

    getSelectedFromThem(arr) {
        if (this.state.notYours === null) {
            return;
        }

        let bool = false;

        for (let x = 0; x < arr.length; x++) {
            if (arr[x].id === this.state.notYours.id) {
                this.setState({ notYours: arr[x] });
                break;
            }
        }
    }

    canSee = () => {
        const _ = FakeData.___(this.props.userType, {
          "can_see_posts":"Friends",
          "can_see_tagged_posts":true,
          "who_to_see_posts":"Friends"
        }, this.props.user, []);
    
        return _;
    }

    onPost(type) {

		if(this.state.isError){
			alert('Please check your post content before submitting');
			return;
		}

		if (this.state.post.content === "" && this.state.post.media.length === 0) {
			return;
		}

		this.setState({ isPosting: true, isSending: false });

		const _that = this;
		const _user = {
			id: this.props.user.isAdmin ? this.props.user.id : FakeData.getData("yoo").id,
			type: this.props.user.isAdmin ? this.props.userType : "F"
		};

		const linkImages = [];
		this.state.linkImages
			.filter((item, i) => {
				return item.id;
			})
			.forEach((item, id) => {
				linkImages.push(item.url);
			});

		const newPost = {
			user: _user,
			userTo: {
				name: this.props.user.name,
				image: this.props.user.image,
				id: this.props.user.id,
				type: this.props.userType
			},
			type: 1,
			postType: "normal",
			sport: type,
			isError: false,
			isEvent: false,
			content: this.state.post.content,
			rawContent: this.state.post.rawContent,
			media: this.state.post.media,
			timeAgo: new Date(),
			isLiked: false,
			likes: [],
			links: this.state.post.links.join(","),
			linkImages: linkImages.join(","),
			place: this.state.post.place,
			shares: [],
			commentType: "post",
			audience: "friends",
			tagged: this.state.post.tags,
			audienceList: this.state.post.audienceList,
			tagsLen: this.state.post.tags.length,
			comments: []
		};

		this.setState((state, props) => {
			return { isPosting: true };
		});

		FakeData.post(
			"/createPost.php?auth0",
			newPost,
			{
				success: res => {
					_that.setState({
						isPosting: false,
						postToken: Date.now(),
						canAddLinkImages: false,
						post: {
							content: "",
							postType: "normal",
							media: [],
							links: [],
							tags: [],
							audienceList: [],
							place: { name: "" },
							coord: { lat: 0, lng: 0 }
						},
						linkImages: [
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							},
							{
								url: false
							}
						],
						isModalOpen: false,
						isTagging: false,
						isWhoToSee: false,
						isSending: false,
						isModalAlbumOpen: false
					});

					if (FakeData.shared("_feeds")) {
						FakeData.shared("_feeds").refreshContent();
					}
				},
				error: err => { }
			},
			true,
			"Post was added to Timeline!",
			null
		);
	}

	onAddFiles(cap, files, type, place, coord) {
		this.state.post.content = cap;
		this.state.post.media = files;
		const placeFor = {
			name: place
		};

		coord = coord ? coord : { lat: 0, lng: 0 };

		this.state.post.place = placeFor;
		this.state.post.coord = coord;

		this.setState({
			post: this.state.post
		});

		this.onPost(type);
	}

    getAlbums = (photos = []) => {
        const _albumNames = photos.map((photo, i)=>{
            return photo.album;
        });

        var uniqueNames = [];
        _albumNames.forEach((n,i)=>{
            if(!FakeData.inArray(n, uniqueNames)){
                uniqueNames.push(n);
            }
        });

        const _albumObjects = {};

        uniqueNames.forEach((n,i)=>{
            _albumObjects[n.name] = {
                data: n,
                photos: []
            }
        });

        photos.forEach((photo, i)=>{
            _albumObjects[photo.album.name].photos.push(photo);
        });

        return _albumObjects;
    };

    render() {
        const _ = this.canSee();
        if(!_.can_see_posts || !_.can_see_tagged_posts || !_.who_to_see_posts){
            return(
                <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                    <EmptyState icon="block" isShown={true} text={"Content viewing was disabled by admin"}/>
                </div>
            )
        }
        const albums = this.getAlbums(this.props.data.uploads);
        return (
            <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.filter((item)=>{
                                return !FakeData.inArray(item,FakeData.listify(this.props.filterArray))
                            }).map((item, i) => {
                                if(this.props.data.tagged.length===0 && (item === "Photos of You" || item === "Photos of " + FakeData.nullify(this.props.author).split(" ")[0])){
                                    return null;
                                }
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item, isManaging : false })}>{(this.props.data.tagged.length===0 && (item === "Your Photos" || item === FakeData.nullify(this.props.author).split(" ")[0] + "'s Photos"))?"Photos":item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body" style={{
                        minHeight: '40px'
                    }}>
                        {this.props.isAdmin &&
                            <div className="my-sports-list-head">
                                {(this.state.activeTab === "Your Photos") &&
                                    <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isModalOpen: true })}>
                                        <span>Add Photos</span>
                                    </div>
                                }
                                {(this.state.activeTab === "Albums") &&
                                    <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isModalAlbumOpen: true })}>
                                        <span>Add Album</span>
                                    </div>
                                }
                                <div className="my-sports-list-head-item manage_photos" onClick={() => {
                                    if (this.state.activeTab === "Photos of You") {
                                        this.setState({ isManaging: (!this.state.isManaging) ? true : false })
                                        return
                                    }

                                    this.setState({ isManaging: true })
                                }}>
                                    {   this.state.activeTab !== "Photos of You" &&
                                        <span>Manage {(this.state.activeTab === "Albums") ? "Albums" : "Photos"}</span>
                                    }
                                    {   this.state.activeTab === "Photos of You" &&
                                        <span> {(this.state.activeTab === "Photos of You" && this.state.isManaging) ? "Cancel" : "Manage Photos"}</span>
                                    }
                                </div>
                            </div>
                        }

                        {(this.state.activeTab === "Your Photos" || this.state.activeTab === FakeData.nullify(this.props.author).split(" ")[0] + "'s Photos") &&
                            <div className="md-items">
                                {
                                    this.props.data.uploads.map((item, i) => {
                                        return (
                                            <PhotoItem onLike={() => this.onLike(item)} isManaging={false} onClick={(e) => {
                                                this.setState({ item: e, isViewingMedia: true });
                                            }} key={i} item={item} />
                                        )
                                    })
                                }
                                <EmptyState isShown={(FakeData.listify(this.props.data.uploads).length === 0) ? true : false} text="No photos were found!" icon="filter_hdr" />
                            </div>
                        }

                        {(this.state.activeTab === "Photos of You" || this.state.activeTab === "Photos of " + FakeData.nullify(this.props.author).split(" ")[0]) &&
                            <div className="md-items">
                                {
                                    this.props.data.tagged.map((item, i) => {
                                        return (
                                            <PhotoItem onLike={() => this.onLike(item)} isManaging={(this.state.isManaging && this.state.activeTab === "Photos of You") ? true : false} onClick={(e) => {
                                                this.setState({ notYours: e, isViewingMedia: true });
                                            }} key={i} item={item} />
                                        )
                                    })
                                }
                                <EmptyState isShown={(FakeData.listify(this.props.data.tagged).length === 0) ? true : false} text="No photos were found!" icon="filter_hdr" />
                            </div>
                        }

                        {this.state.activeTab === "Albums" &&
                            <Albums albums={albums}/>
                        }
                    </div>
                </div>
                {this.state.item !== null &&
                    <FilePostViewer pos={0} onLike={() => this.onLike(this.state.item)} post={this.state.item} isOpen={this.state.isViewingMedia} onClose={() => {
                        this.setState({
                            isViewingMedia: false,
                            item: null
                        });
                    }} />
                }
                {this.state.notYours !== null &&
                    <FilePostViewer pos={0} onLike={() => this.onLike(this.state.notYours)} post={this.state.notYours} isOpen={this.state.isViewingMedia} onClose={() => {
                        this.setState({
                            isViewingMedia: false,
                            notYours: null
                        });
                    }} />
                }
                {this.state.isModalOpen && (
					<PhotoAddModal
						isAdmin={this.props.user.isAdmin}
						toId={this.props.user.id}
						toType={this.props.userType}
						isTeam={true}
						onPost={this.onAddFiles}
						url={
							FakeData.URL +
							"/uploadMedia.php?auth0&userType=" +
							(this.props.user.isAdmin ? this.props.userType : "F") +
							"&userId=" +
							this.props.user.id
						}
						user={FakeData.you()}
						isOpen={this.state.isModalOpen}
						onClose={() =>
							this.setState({
								isModalOpen: false
							})
						}
					/>
				)}

				{this.state.isModalAlbumOpen && (
					<AlbumAddModal
						isAdmin={this.props.user.isAdmin}
						toId={this.props.user.id}
						toType={this.props.userType}
						onPost={this.onAddFiles}
						url={
							FakeData.URL +
							"/uploadMedia.php?auth0&userType=" +
							(this.props.user.isAdmin ? this.props.userType : "F") +
							"&userId=" +
							this.props.user.id
						}
						user={FakeData.you()}
						isOpen={this.state.isModalAlbumOpen}
						onClose={() =>
							this.setState({
								isModalAlbumOpen: false
							})
						}
					/>
				)}
            </div>
        );
    }
}

class PhotoItem extends Component {
    constructor(p) {
        super(p)
        this.state = {
            isViewingMedia: false
        }
    }

    render() {
        const item = this.props.item;
        return (
            <div className={(this.props.isManaging)?"md-item is-managing":"md-item"}>
                {this.props.isManaging &&
                    <span>x</span>
                }
                <img src={item.url} onClick={() => this.props.onClick(item)}/>
                <div className="md-item-actions">
                    <div className="md-item-action" onClick={() => this.props.onLike()}>
                        <i className="material-icons">thumb_up</i>
                        <span>{((item.likes.length / 6) > 1000000) ? item.likes.length / 6 + 'm likes' : ((item.likes.length / 3) > 1000) ? item.likes.length / 3 + 'k likes' : (item.likes.length == 1) ? item.likes.length + ' like' : (item.likes.length == 0) ? 'Like' : item.likes.length + ' likes'}</span>
                    </div>
                    <div className="md-item-action" onClick={() => this.props.onClick(item)}>
                        <i className="material-icons">chat_bubble</i>
                        <span>{((item.comments.length / 6) > 1000000) ? item.comments.length / 6 + 'm likes' : ((item.comments.length / 3) > 1000) ? item.comments.length / 3 + 'k comments' : (item.comments.length == 1) ? item.comments.length + ' comment' : (item.comments.length == 0) ? 'Comment' : item.comments.length + ' comments'}</span>
                    </div>
                    <div className="md-item-action">
                        <i className="material-icons" style={{ transform: "rotateY(-180deg)" }}>reply</i>
                        <span>{((item.shares.length / 6) > 1000000) ? item.shares.length / 6 + 'm likes' : ((item.shares.length / 3) > 1000) ? item.shares.length / 3 + 'k shares' : (item.shares.length == 1) ? item.shares.length + ' share' : (item.shares.length == 0) ? 'Share' : item.shares.length + ' shares'}</span>
                    </div>
                </div>
            </div>
        )
    }
}

class Albums extends Component{
    constructor(p){
        super(p)
        this.state = {

        }
    }

    render(){
        const {albums} = this.props;
        if(Object.keys(albums).length === 0){
            return(
                <EmptyState isShown={true} text="No albums were found!" icon="filter_hdr" />
            )
        }
        return(
            <View className="md-items" style={{
                flex: 1,
                flexDirection: 'row'
            }}>
                {
                    Object.keys(albums).map((item, i)=>{
                        return(
                            <div key={item} className={"album--seinabo-younger md-item"} style={{
                                background: `url(${albums[item].photos[0].media[0].url})`
                            }}>
                                <h1>{item}</h1>
                            </div>
                        )
                    })
                }
            </View>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Photos.js